import type { Position } from '$lib/types/position';
import { editPairOrder, executePairOrder } from '$lib/web3/actions/tradeStandard';
import { get } from 'svelte/store';
import {
	loadingTPSL,
	popupModalOpen,
	positionData,
	stopLossInput,
	takeProfitInput,
	tpslPostTradeDetails,
	tpslPostTradeDetailsLoading
} from '../popupsStore';
import { limitOrderExpiryTimestamp, priceImpactDelta } from '$lib/home/userInteract/store';
import { smartContractWalletAddress } from '$lib/home/scwallet/store';
import {
	addErrorNotification,
	addTransactionNotification
} from '$lib/notifications/notificationManager';
import { makeBodyScrollable } from '$lib/util/util';
import { tpslBeingUpdated } from '$lib/home/store';
import type { PostTradeDetails } from '$lib/types/userInteract';
import { fetchPostTradeDetails } from '$lib/apis/userInteract';
import { ordersRaw } from '$store/orders';

function updateData() {
	for (let i = 0; i < 5; i++) {
		setTimeout(() => {
			ordersRaw.apiCall({});
			if (i === 4)
				tpslBeingUpdated.set(
					get(tpslBeingUpdated).filter((asset) => asset !== get(positionData).asset)
				);
		}, 4000 + 3000 * i);
	}
}

export async function submitTPSL() {
	loadingTPSL.set(true);
	tpslBeingUpdated.set([...get(tpslBeingUpdated), get(positionData).asset]);

	const _positionData = get(positionData) as Position;
	if (_positionData.tpslOrderId !== undefined) {
		try {
			const tx = await editPairOrder(
				_positionData.tpslOrderId,
				_positionData.marketIdentifier,
				_positionData.size,
				true,
				get(priceImpactDelta),
				get(limitOrderExpiryTimestamp),
				get(takeProfitInput),
				get(stopLossInput),
				get(smartContractWalletAddress) as `0x${string}`
			);

			addTransactionNotification(
				'Transaction Confirmed',
				'Your TP/SL order has been submitted.',
				tx,
				() => {
					updateData();
				}
			);
		} catch (error) {
			addErrorNotification(
				'Transaction Failed',
				'Your TP/SL order has failed.',
				JSON.stringify(error)
			);
			tpslBeingUpdated.set(
				get(tpslBeingUpdated).filter((asset) => asset !== get(positionData).asset)
			);
		} finally {
			loadingTPSL.set(false);
			popupModalOpen.set(false);
			makeBodyScrollable();
		}
	} else
		try {
			const tx = await executePairOrder(
				_positionData.marketIdentifier,
				_positionData.size,
				true,
				get(priceImpactDelta),
				get(limitOrderExpiryTimestamp),
				get(takeProfitInput),
				get(stopLossInput),
				get(smartContractWalletAddress) as `0x${string}`
			);

			addTransactionNotification(
				'Transaction Confirmed',
				'Your TP/SL order has been submitted.',
				tx
			);
		} catch (error) {
			addErrorNotification(
				'Transaction Failed',
				'Your TP/SL order has failed.',
				JSON.stringify(error)
			);
			tpslBeingUpdated.set(
				get(tpslBeingUpdated).filter((asset) => asset !== get(positionData).asset)
			);
		} finally {
			loadingTPSL.set(false);
			popupModalOpen.set(false);
			makeBodyScrollable();
			updateData();
		}
}

export async function getPostTradeDetailsForTPSL() {
	const _positionData = get(positionData) as Position;
	tpslPostTradeDetailsLoading.set(true);
	const data: PostTradeDetails = (await fetchPostTradeDetails(
		_positionData.size,
		_positionData.marketIdentifier,
		_positionData.margin
	)) as PostTradeDetails;

	tpslPostTradeDetails.set(data);
	tpslPostTradeDetailsLoading.set(false);
}
